import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonType } from '@core/constants/enum.common';
import { ButtonIconType } from '@core/models/enums/common.enum';

@Component({
  selector: 'caremoni-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {

  @Input()  xdpad?: number = -1;
  @Input()  ydpad?: number = -1;
  @Input()  dpad?: number = -1;
  @Input()  scaledpad?: number = -1;
  @Input() cssCustom?: boolean = false;
  @Input() iconType: ButtonIconType | undefined;
  @Input() buttonText: string = "";
  @Input() buttonType: ButtonType = ButtonType.SECONDARY;
  @Input() disabled: boolean = false;
  @Input() buttonStyle: any = {};
  @Input() imgUrl: any = null;
  @Output() btnClick = new EventEmitter();
  @Output() btnMouseOver = new EventEmitter();
  @Output() btnMouseOut = new EventEmitter();

  clickHandler(){
    this.btnClick.emit();
  }

  onMouseOver() {
    this.btnMouseOver.emit();
  }

  onMouseOut() {
    this.btnMouseOut.emit();
  }
}